export const mapConditions = (response) => {
    return response.value;
};
